




















































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { GetBackgroundInfo } from "@/services/backgrounds/backgroundService";
import { BackgroundInfo } from "@/services/backgrounds/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

@Component
export default class BackgroundInfoModal extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    backgroundInfo = {} as BackgroundInfo;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    open(backgroundId: string) {
        GetBackgroundInfo(backgroundId).then(response => {
            this.backgroundInfo = response;
            this.$bvModal.show("modal-backgroundInfo");
        });
    }

    channelSettings(channelId: string) {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
            return {
                name: "updatechannel",
                params: { channelId: channelId }
            };
        } else {
            return {
                name: "editorupdatechannel",
                params: { channelId: channelId }
            };
        }
    }

    updateTemplate(templateId: string) {
        return {
            name: "updatetemplate",
            params: { templateId: templateId }
        };
    }

    hide() {
        this.$bvModal.hide("modal-backgroundInfo");
    }
}
